const guiColors = {
    'motion-primary': 'hsla(330, 80%, 70%, 1)',
    'motion-primary-transparent': 'hsla(330, 80%, 70%, 0.9)',
    'motion-tertiary': 'hsla(330, 60%, 55%, 1)',

    'looks-secondary': 'hsla(330, 80%, 70%, 1)',
    'looks-transparent': 'hsla(330, 80%, 70%, 0.35)',
    'looks-light-transparent': 'hsla(330, 80%, 70%, 0.15)',
    'looks-secondary-dark': 'hsla(330, 60%, 55%, 1)'
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
